import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightLong = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M37.5043 21.2001C38.1652 20.5392 38.1652 19.4705 37.5043 18.8167L27.9428 9.2481C27.2819 8.58722 26.2133 8.58722 25.5594 9.2481C24.9056 9.90897 24.8985 10.9776 25.5594 11.6315L32.2385 18.3105L3.68734 18.3175C2.75227 18.3175 2 19.0698 2 20.0049C2 20.9399 2.75227 21.6922 3.68734 21.6922H32.2385L25.5594 28.3712C24.8985 29.0321 24.8985 30.1007 25.5594 30.7546C26.2203 31.4084 27.2889 31.4155 27.9428 30.7546L37.5043 21.2001Z" })
});
export default SvgArrowRightLong;
